import { Normas_urbanisticas } from './../../../models/normas_urbanisticas.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';


@Component({
    selector: "page-normas_urbanisticas",
    templateUrl: "./normas_urbanisticas.component.html",
    styleUrls: ["./normas_urbanisticas.component.css"],
    providers: [FormService]
})

export class Normas_urbanisticasComponent {
    public rows = [];
    public actualRow;
    public normas_urbanisticas: Normas_urbanisticas;
    public form;

    public matcher = new FormService();

      constructor(){

        this.form = new FormGroup({
            constr_perm: new FormControl(''),
            constr_proy: new FormControl(''),
            ocup_perm: new FormControl(''),
            ocup_proy: new FormControl(''),
            alt_perm: new FormControl(''),
            alt_proy: new FormControl(''),
            rasant_perm: new FormControl(''),
            rasant_proy: new FormControl(''),
            dist_perm: new FormControl(''),
            dist_proy: new FormControl(''),
            suelo_perm: new FormControl(''),
            suelo_proy: new FormControl(''),
            densid_perm: new FormControl(''),
            densid_proy: new FormControl(''),
            adosam_perm: new FormControl(''),
            adosam_proy: new FormControl(''),
            antej_perm: new FormControl(''),
            antej_proy: new FormControl(''),
            est_req: new FormControl(''),
            est_proy: new FormControl(''),
        })

        if(!JSON.parse(localStorage.getItem("normas_urbanisticas"))){
            localStorage.setItem("normas_urbanisticas", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("normas_urbanisticas"));
            this.form.controls['constr_perm'].setValue(this.rows[0]?this.rows[0].constr_perm:'')
            this.form.controls['constr_proy'].setValue(this.rows[0]?this.rows[0].constr_proy:'')
            this.form.controls['ocup_perm'].setValue(this.rows[0]?this.rows[0].ocup_perm:'')
            this.form.controls['ocup_proy'].setValue(this.rows[0]?this.rows[0].ocup_proy:'')
            this.form.controls['alt_perm'].setValue(this.rows[0]?this.rows[0].alt_perm:'')
            this.form.controls['alt_proy'].setValue(this.rows[0]?this.rows[0].alt_proy:'')
            this.form.controls['rasant_perm'].setValue(this.rows[0]?this.rows[0].rasant_perm:'')
            this.form.controls['rasant_proy'].setValue(this.rows[0]?this.rows[0].rasant_proy:'')
            this.form.controls['dist_perm'].setValue(this.rows[0]?this.rows[0].dist_perm:'')
            this.form.controls['dist_proy'].setValue(this.rows[0]?this.rows[0].dist_proy:'')
            this.form.controls['suelo_perm'].setValue(this.rows[0]?this.rows[0].suelo_perm:'')
            this.form.controls['suelo_proy'].setValue(this.rows[0]?this.rows[0].suelo_proy:'')
            this.form.controls['densid_perm'].setValue(this.rows[0]?this.rows[0].densid_perm:'')
            this.form.controls['densid_proy'].setValue(this.rows[0]?this.rows[0].densid_proy:'')
            this.form.controls['adosam_perm'].setValue(this.rows[0]?this.rows[0].adosam_perm:'')
            this.form.controls['adosam_proy'].setValue(this.rows[0]?this.rows[0].adosam_proy:'')
            this.form.controls['antej_perm'].setValue(this.rows[0]?this.rows[0].antej_perm:'')
            this.form.controls['antej_proy'].setValue(this.rows[0]?this.rows[0].antej_proy:'')
            this.form.controls['est_req'].setValue(this.rows[0]?this.rows[0].est_req:'')
            this.form.controls['est_proy'].setValue(this.rows[0]?this.rows[0].est_proy:'')
        }
        
        //this.normas_urbanisticas = {constr_perm:'',constr_proy:'', ocup_perm:'', ocup_proy:'', alt_perm:'', alt_proy:'', rasant_perm:'', rasant_proy:'', dist_perm:'',dist_proy:'',suelo_perm:'',suelo_proy:'', densid_perm:'', densid_proy:'', adosam_perm:'', adosam_proy:'', antej_perm:'', antej_proy:'', est_req:'', est_proy:'' };
   }

    add_normas_urbanisticas(){
        localStorage.setItem("normas_urbanisticas",JSON.stringify([]));
        this.actualRow = localStorage.getItem("normas_urbanisticas");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            constr_perm: this.form.value.constr_perm,
            constr_proy: this.form.value.constr_proy,
            ocup_perm: this.form.value.ocup_perm,
            ocup_proy: this.form.value.ocup_proy,
            alt_perm: this.form.value.alt_perm,
            alt_proy: this.form.value.alt_proy,
            rasant_perm: this.form.value.rasant_perm,
            rasant_proy: this.form.value.rasant_proy,
            dist_perm: this.form.value.dist_perm,
            dist_proy: this.form.value.dist_proy,
            suelo_perm: this.form.value.suelo_perm,
            suelo_proy: this.form.value.suelo_proy,
            densid_perm: this.form.value.densid_perm,
            densid_proy: this.form.value.densid_proy,
            adosam_perm:this.form.value.adosam_perm,
            adosam_proy:this.form.value.adosam_proy,
            antej_perm: this.form.value.antej_perm,
            antej_proy: this.form.value.antej_proy,
            est_req: this.form.value.est_req,
            est_proy: this.form.value.est_proy
            
        })
        localStorage.setItem("normas_urbanisticas", JSON.stringify(this.rows));
    }

    delete_normas(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("normas_urbanisticas", JSON.stringify(this.rows));
            }
        }
    }
}